import styled from "styled-components";

const StyledFolder = styled.div`
    width: 100%;
    height: 100%;
    
    & h3 {
        color: #fff;
    }
`

export default StyledFolder;